{
  "translate": "Traduire",
  "done": "Terminé",
  "amount": "Montant",
  "timeline": "Calendrier",
  "moneyAvailable": "Trésorerie disponible",
  "marketValue": "Total des actifs",
  "availableFundsToWithdraw": "Fonds disponibles pour retrait",
  "netContributions": "Contributions nettes",
  "simpleReturnPercent": "Taux de rendement simple",
  "timeWeightedReturn": "Taux de rendement pondéré dans le temps",
  "moneyWeightedReturn": "Taux de rendement pondéré",
  "newContribution": "Nouvelles contributions (aujourd'hui)",
  "cashOnHoldToWithdraw": "Trésorerie en attente de retrait",
  "cashOnHoldToTrade": "Trésorerie en attente de négociation",
  "startDate": "Date de début",
  "subAccount": "Sous-compte",
  "suspicious": "Suspicieux",
  "notSuspicious": "Non suspicieux",
  "suspiciousActivity": "Activité suspecte",
  "suspiciousActivityDetected": "Activité suspecte détectée",
  "noSuspiciousActivity": "Aucune activité suspecte",
  "fraudRiskScore": "Score de risque de fraude",
  "lastUpdatedBy": "Mis à jour par",
  "riskReasons": "Motifs du risque",
  "clientGroup": "Groupe de clients",
  "corporation": "Entreprise",
  "household": "Famille",
  "edit": "Modifier",
  "accountHighlights": "Points saillants du compte",
  "highlights": "Faits saillants",
  "groupEmployer": "Employeur du groupe",
  "groupNumber": "Numéro de groupe",
  "displaySettledCash": "Liquidités réglées",
  "displayUnsettledCash": "Liquidités non réglées",
  "displayAccountRepCode": "Code représentant",
  "portfolioHighlights": "Faits saillants du portefeuille",
  "accountNo": "Compte nº",
  "accountOwners": "Propriétaires",
  "accountOwner": "Titulaire",
  "status": "Statut",
  "YTDContributions": "{{label}} depuis le début de l'année",
  "first60DaysContributions": "{{label}} dans les 60 premiers jours de {{year}}",
  "last10MonthsContributions": "Reste de l'année {{year}}",
  "withdrawalsCurrentYear": "Retraits de l'année en cours",
  "minWithdrawalCurrentYear": "Retrait minimum pour l'année en cours",
  "maxWithdrawalCurrentYear": "Retrait maximum pour l'année en cours",
  "YTDDeposits": "Dépôts depuis le début de l'année",
  "YTDWithdrawals": "Retraits depuis le début de l'année",
  "governContributions": "{{label}} gouvernementales",
  "currentYearContributions": "{{label}} sur l'année actuelle",
  "currentYearWithdrawals": "Retraits sur l'année actuelle",
  "priorYearContributions": "{{label}} sur l'année précédente",
  "priorYearWithdrawals": "Retraits sur l'année précédente",
  "portfolioFundFacts": "Informations sur le fonds",
  "languages": {
    "label": "Langue préférée"
  },
  "languageSelection": {
    "language": "Langue",
    "languageList": {
      "en": "English",
      "fr": "Français",
      "es": "Español"
    }
  },
  "notificationSettings": {
    "title": "Paramètres de notification du bureau",
    "options": {
      "inApp": "Dans l'application",
      "push": "Notification poussée",
      "email": "Courriel"
    }
  },
  "updateAvatar": {
    "title": "Mettre à jour l'avatar"
  },
  "gender": "Genre",
  "preferredMethodOfCommunication": {
    "label": "Moyen de communication préféré"
  },
  "bankAccountSelect": {
    "addBank": "Ajouter un compte bancaire",
    "information": {
      "header": "Ajouter un compte bancaire",
      "title": "Reliez en toute sécurité vos comptes bancaires et vos comptes de placement pour simplifier vos investissements.",
      "body": "Le chiffrage des données au niveau bancaire garantit la protection de vos renseignements. Aucun identifiant n'est enregistré.",
      "addAccountBtn": "Ajouter un compte",
      "addManuallyBtn": "Je veux ajouter mon compte manuellement"
    },
    "flinks": {
      "addManually": "Je veux ajouter mon compte manuellement",
      "linkingTimeInfo": "L'association peut prendre jusqu'à 5 minutes…",
      "linkingRedirectionInfo": "Une fois votre compte bancaire lié avec succès, vous serez automatiquement redirigé vers l'écran précédent."
    },
    "addBankModal": {
      "title": "Ajouter un compte bancaire",
      "bankAccountName": "Nom du compte bancaire",
      "institutionNumber": "Numéro de l'institution",
      "transitNumber": "Numéro de transit",
      "bankAccount": "Compte bancaire",
      "inputErrors": {
        "bankAccountNameCannotBeEmpty": "Le nom du compte bancaire ne peut pas être vide",
        "institutionNumberCannotBeEmpty": "Le numéro de l'institution ne peut pas être vide",
        "routingNumberCannotBeEmpty": "Le numéro d'acheminement ne peut pas être vide",
        "institutionNumberLength": "Le numéro de l'institution doit comporter 3 chiffres",
        "routingNumberLength": "Le numéro d'acheminement doit comporter 9 chiffres",
        "transitNumberCannotBeEmpty": "Le numéro de transit ne peut pas être vide",
        "transitNumberLength": "Le numéro de transit doit comporter 5 chiffres",
        "bankAccountNumberCannotBeEmpty": "Le numéro de compte bancaire ne peut pas être vide",
        "bankAccountNumberRange": "Le compte bancaire doit comporter entre 5 et 17 caractères",
        "usBankAccountNumberRange": "Le numéro de compte bancaire doit comporter entre 8 et 12 chiffres"
      }
    },
    "addBankManuallyModal": {
      "title": "Ajouter un compte bancaire",
      "subTitle": "Veuillez saisir les renseignements du titulaire du compte et importer un chèque nul correspondant au compte que vous souhaitez ajouter",
      "bankAccountName": "Nom du compte bancaire",
      "transitNumber": "Nº Transit",
      "institutionNumber": "Nº Institution",
      "accountNumber": "Compte #",
      "bankAccount": "Compte bancaire",
      "addBankAccount": "Ajouter un compte",
      "linkFlinksButton": "Je veux ajouter mon compte automatiquement",
      "inputErrors": {
        "transitNumber": "Veuillez entrer un numéro de transit valide",
        "accountNumber": "Veuillez entrer un numéro de compte bancaire valide"
      },
      "bankAccountHolderName": "Nom du titulaire du compte bancaire (facultatif)",
      "bankTransitAddress": "Adresse de transit de la banque (facultatif)",
      "bankCountry": "Juridiction bancaire",
      "routingNumber": "N° d'acheminement"
    },
    "deleteBankAccountModal": {
      "title": "Confirmez-vous?",
      "body": "Vous ne pourrez pas récupérer ce compte bancaire et devrez en ajouter un autre."
    },
    "confirmationDialogTitle": "Confirmez-vous?",
    "bankAccountAddedIntegrationToastMessage": "Le compte bancaire a été ajouté avec succès.",
    "bankAccountAddedToastMessage": "Le compte bancaire a été ajouté avec succès grâce au chèque annulé téléchargé.",
    "bankAccountAddedToastMessageError": "Impossible d'ajouter un compte bancaire. Veuillez réessayer ou contacter le service de soutien."
  },
  "address": {
    "title": "Modifier - Adresse",
    "unitNumber": "Numéro de l'unité",
    "houseNumber": "Numéro de rue",
    "streetName": "Nom de rue",
    "city": "Ville",
    "province": "Province",
    "state": "État",
    "postal": "Code postal",
    "postcode": "Code postal",
    "zip": "Code ZIP",
    "jurisdiction": "Compétence",
    "mailAddressCheck": "Votre adresse postale est-elle différente de votre adresse personnelle/légale ?",
    "alternateAddressCheck": "Avez-vous une autre adresse différente de votre adresse postale et de votre domicile ?",
    "line1": "Ligne 1",
    "line2": "Ligne 2",
    "country": "Pays",
    "enterYourAddressManually": "Entrez manuellement votre adresse",
    "here": "ici.",
    "error": {
      "unSupportedCountry": "Le pays sélectionné n'est pas pris en charge. Veuillez communiquer avec votre conseiller pour obtenir de l'aide.",
      "unSupportedProvince": "La province sélectionnée n'est pas prise en charge. Veuillez communiquer avec votre conseiller pour obtenir de l'aide.",
      "suggestionsUnavailable": "Les suggestions d'adresse ne sont pas disponibles pour le moment. Veuillez saisir votre adresse manuellement."
    },
    "clearAddress": "Effacer l'adresse"
  },
  "citizenshipInput": {
    "label": "Citoyennetés",
    "searchLabel": "Pays",
    "updateButton": "METTRE À JOUR"
  },
  "transferTransitions": {
    "initiate": "Initier",
    "ready": "Prêt",
    "request": "Demander",
    "process": "Traiter",
    "reconcile": "Rapprocher",
    "review": "Examiner",
    "fail": "Échec",
    "cancel": "Annuler",
    "cancelReconciled": "Annuler",
    "reason": "Motif",
    "cancelScheduled": "Annuler",
    "failtitle": "Échec du virement",
    "canceltitle": "Annuler le virement",
    "abort": "Interrompre",
    "confirm": "Confirmer",
    "flipCancelToReconcile": "Rapprocher le virement",
    "editScheduled": "Modifier le virement programmé"
  },
  "transferTable": {
    "state": "État",
    "type": "Type",
    "source": "Source"
  },
  "tradeTransitions": {
    "process": "Traiter",
    "reconcile": "Rapprocher",
    "fail": "Échec",
    "cancel": "Annuler",
    "forceCancel": "Annuler",
    "cancelReconciled": "Annuler"
  },
  "reportTransitions": {
    "review": "Examiner",
    "approved": "Approuvé",
    "denied": "Refusé"
  },
  "loginSettings": {
    "title": "Gérer la connexion",
    "changePassword": "Modifier le mot de passe",
    "resetPasswordSuccess": "Nous vous avons envoyé un courriel pour réinitialiser votre mot de passe."
  },
  "activityTable": {
    "client": "Client",
    "account": "Compte",
    "accountType": "Type de compte",
    "type": "Type",
    "source": "Source",
    "sourceId": "ID de la source",
    "amount": "Montant",
    "state": "État",
    "autoTransfer": "Virement automatique",
    "frequency": "Fréquence",
    "nextScheduledDate": "Date suivante programmée",
    "createdAt": "Créé",
    "reconciledAt": "Rapproché",
    "actions": "Actions",
    "alertState": "État d'alerte",
    "alert": "Alerte",
    "alertDescription": "Description",
    "fraudRisk": "Risque de fraude",
    "noTransfersExist": "Aucun virement disponible",
    "noTransfersExistWithFilter": "Aucun transfert ne correspond aux critères de filtrage",
    "noScheduledTransfersExist": "Vous n'avez aucun transfert prévu",
    "noUpcomingTransfersExist": "Vous n'avez aucune transaction à venir",
    "noScheduledIncomeFundTransfersExist": "Aucun virement de fonds de revenu programmé disponible",
    "dob": "Date de naissance",
    "depositTo": "Dépôt sur",
    "paymentType": "Type de paiement",
    "instantInvest": "Investissement instantané",
    "initiatedByRepresentative": "Initié par un représentant",
    "organization": "Organisation",
    "scheduledDate": "Date programmée",
    "bankAccount": "Compte bancaire",
    "bankAccountId": "ID du compte bancaire",
    "subAccount": "Sous-compte",
    "failReason": "Motif de l'échec",
    "user": "Utilisateur",
    "userFirstName": "Prénom de l'utilisateur",
    "userMiddleName": "Deuxième prénom de l'utilisateur",
    "userLastName": "Nom de famille de l'utilisateur",
    "endDate": "Date de fin",
    "toSubAccount": "Vers le sous-compte",
    "transferAll": "Tout virer",
    "withdrawalReason": "Motif du retrait",
    "withdrawalReasonDescription": "Description du motif de retrait",
    "subAccountGoalName": "Nom de l'objectif du sous-compte",
    "subAccountAccountType": "Type de compte du sous-compte",
    "unrealizedGainsAndLossCents": "Gains et pertes non réalisés (en cents)",
    "unrealizedGainsAndLossCentsPercentage": "Gains et pertes non réalisés (pourcentage)",
    "accountFileName": "Comptes",
    "lastSkippedAt": "Dernière omission",
    "lastSkipReason": "Motif de la dernière omission"
  },
  "custodianActivities": {
    "exportProgressTitle": "Exportation d'activités externes",
    "title": "Activités de gardiennage",
    "accountId": "Identifiant du compte",
    "accountType": "Type de compte",
    "accountNumber": "Numéro de compte",
    "transactionType": "Type de transaction",
    "transactionDesc": "Description",
    "currency": "Devise",
    "security": "Sécurité",
    "quantity": "Quantité",
    "price": "Prix",
    "amount": "Montant",
    "state": "État",
    "effectiveDate": "Date d'entrée en vigueur",
    "processDate": "Date de traitement",
    "settleDate": "Date de règlement",
    "modal": {
      "activityDetails": "Détails de l'activité",
      "reconcileButton": "Rapprocher",
      "forceReconcileButton": "Forcer le rapprochement"
    }
  },
  "transfers": {
    "title": "Virements",
    "exportProgressTitle": "Exportation des transferts",
    "exportProgressTitleOneOff": "Exporter les virements",
    "exportProgressTitleScheduled": "Exportation des transferts planifiés",
    "transferDetails": "Détails du virement",
    "transferProgress": "Progression du virement",
    "source": "Source",
    "date": "Date programmée",
    "frequency": "Fréquence",
    "setState": "Définir l'état",
    "confirmationDialog": {
      "cancelScheduled": "Cela annulera tous les virements futurs prévus pour cette série. Voulez-vous continuer ?",
      "cancel": "Cela annulera le transfert. Voulez-vous continuer ?"
    },
    "cancel": "Non, conserver le transfert",
    "confirm": "Oui, annuler le virement",
    "transitionSuccess": "État de virement modifié avec succès",
    "cancelTransferSuccess": "Virement annulé avec succès",
    "cancelScheduledTransferSuccess": "Virement planifié annulé avec succès",
    "createAdjustmentTransfer": "Ajouter",
    "createAdjustmentTransferTitle": "Créer un virement d'ajustement",
    "lastSkipped": "Dernière omission",
    "lastSkippedOn": "Dernière omission le {{date}}",
    "lastSkipReason": "Motif de l'omission"
  },
  "transferUpdate": {
    "sourceIdRequired": "L'ID de la source est obligatoire",
    "bankAccountIdRequired": "L'ID du compte bancaire est obligatoire"
  },
  "transfersTable": {
    "tableHeader": "Virements",
    "scheduleTableHeader": "Virements programmés",
    "paymentInstructions": "Instructions de paiement",
    "yes": "Oui",
    "no": "Non",
    "frequencyOption": {
      "ONE_TIME": "Une fois",
      "DAILY": "Quotidien",
      "WEEKLY": "Hebdomadaire",
      "SEMI_MONTHLY": "Bimensuel",
      "MONTHLY": "Mensuel",
      "BI_WEEKLY": "Bihebdomadaire",
      "QUARTERLY": "Trimestriel"
    },
    "addTransfer": "Ajouter un virement",
    "userFirstName": "Prénom de l'utilisateur",
    "userLastName": "Nom de famille de l'utilisateur",
    "account": "Identifiant du compte",
    "subAccount": "Identifiant du sous-compte",
    "bankAccount": "Identifiant du compte bancaire",
    "custodianAccountNumber": "Numéro de compte du bénéficiaire",
    "dividendFor": "Dividende pour",
    "source": "Source",
    "sourceId": "Identifiant de la source",
    "value:": "Valeur",
    "createdAt": "Créé",
    "reconciledAt": "Rapproché"
  },
  "trades": {
    "title": "Opérations",
    "tradeDetails": "Détails des opérations",
    "exportProgressTitle": "Exporter les opérations",
    "tradeProgress": "Progression des opérations",
    "quantity": "Quantité",
    "estimatedQuantity": "Quantité estimée",
    "security": "Valeur mobilière",
    "symbol": "Symbole",
    "price": "Prix",
    "estimatedPrice": "Prix estimé"
  },
  "tradeTable": {
    "noTradesExist": "Vous n'avez aucun ordre de transaction",
    "client": "Client",
    "account": "Compte",
    "custodianAccountNumber": "Numéro de compte du bénéficiaire",
    "type": "Type",
    "security": "Valeur mobilière",
    "quantity": "Quantité",
    "price": "Prix",
    "actualQuantity": "Quantité réelle",
    "actualPrice": "Prix ​​réel",
    "expectedQuantity": "Quantité prévue",
    "expectedPrice": "Prix prévu",
    "expectedTotalValue": "Valeur commerciale",
    "totalValue": "Valeur",
    "state": "État",
    "tradeDate": "Date de l'opération",
    "settlementDate": "Date de règlement",
    "createdAt": "Créé",
    "reconciledAt": "Rapproché",
    "actions": "Actions",
    "cancel": "Annuler",
    "remove": "Retirer de l'exécution de l'opération groupée",
    "currency": "Devise",
    "rebalance": "Rééquilibrer",
    "user": "Utilisateur",
    "userFirstName": "Prénom de l'utilisateur",
    "userLastName": "Nom de famille de l'utilisateur",
    "organization": "Organisation"
  },
  "bulkTradeRunAllocationsTable": {
    "externalId": "Identifiant externe",
    "account": "Compte",
    "settlementCurrency": "Devise de règlement",
    "tradeCurrency": "Devise de l'opération",
    "side": "Côté",
    "symbol": "Symbole",
    "market": "Marché",
    "fillPrice": "Prix de l'exécution d'opération",
    "shareQuantity": "Partager la quantité",
    "tradeDate": "Date de l'opération",
    "settlementDate": "Date de règlement",
    "tradeValue": "Valeur commerciale",
    "corporateOffsetAccount": "Compte de contrepartie d'entreprise",
    "fXRate": "Taux de change"
  },
  "any": "Peu importe",
  "close": "Fermer",
  "type": "Type",
  "filter": "Filtre",
  "fromDate": "De",
  "toDate": "À",
  "security": "Valeur mobilière",
  "upcomingTransaction": {
    "fileName": "Transactions en attente",
    "progressTitle": "Transactions d'emballage en attente",
    "errorStateTitleUpcomingTransactions": "Impossible de charger les transactions"
  },
  "transaction": {
    "title": "Transactions passées",
    "noTransactions": "Vous n'avez aucune transaction passée",
    "errorStateTitleLedgerTransactions": "Impossible de charger les transactions",
    "noTransactionsExistWithFilter": "Aucune transaction ne correspond aux critères de filtrage",
    "fileName": "transactions",
    "progressTitle": "Transactions d'emballage",
    "exportProgressTitle": "Exporter les transactions",
    "requested": "Demandé",
    "reconciled": "Rapproché",
    "pendingConfirmation": "Confirmation en attente",
    "expectedSettlementDate": "Règlement prévu le : {{settlementDate}}",
    "estimateFinalValue": "L'estimation peut ne pas correspondre à la valeur finale",
    "table": {
      "client": "Client",
      "account": "Compte",
      "accountType": "Type de compte",
      "type": "Type",
      "switchType": "Changer de type",
      "quantity": "Quantité",
      "valueCents": "Valeur",
      "date": "Date",
      "initiatedDate": "Date d'initiation",
      "processedDate": "Date de traitement",
      "description": "Détails",
      "actions": "Actions",
      "state": "État",
      "source": "Source",
      "goal": "Objectif",
      "frequency": "Fréquence",
      "priceCents": "Coût d'acquisition",
      "bookCost": "Coût comptable (prix de base rajusté/unité)",
      "bookValue": "Valeur comptable",
      "currency": "Devise",
      "settleDate": "Date de règlement",
      "settleDateToWithdraw": "Date de règlement pour le retrait",
      "subAccount": "Sous-compte",
      "user": "Utilisateur",
      "userFirstName": "Prénom de l'utilisateur",
      "userLastName": "Nom de famille de l'utilisateur",
      "organization": "Organisation",
      "objectType": "Type d'objet",
      "objectId": "Identifiant de l'objet",
      "householdClientGroup": "Groupe client famille"
    },
    "actions": {
      "update": "Mettre à jour",
      "delete": "Supprimer"
    },
    "types": {
      "EFT": "Transfert électronique de fonds",
      "CANCEL_EFT": "Transfert électronique de fonds annulé",
      "BUY": "Opération d'achat",
      "CANCEL_BUY": "Opération d'achat annulée",
      "DSC_FEE": "Frais de rachat différé",
      "SELL": "Opération de vente",
      "CANCEL_SELL": "Opération de vente annulée",
      "DIVIDEND": "Dividende",
      "EXTERNAL_TRANSFER_IN": "Virement externe entrant",
      "EXTERNAL_TRANSFER_OUT": "Virement externe sortant",
      "TRANSFER_IN": "À partir d'un autre portefeuille",
      "TRANSFER_OUT": "Vers un autre portefeuille",
      "CANCEL_TRANSFER": "Virement annulé",
      "CORPORATE_ACTION": "Action d'entreprise",
      "CANCEL_CORPORATE_ACTION": "Action d'entreprise annulée",
      "MANAGEMENT_FEE": "Frais de gestion",
      "CANCEL_MANAGEMENT_FEE": "Frais de gestion annulé",
      "BORROW_FEE": "Frais d'emprunt",
      "MISC_FEE": "Frais divers",
      "INTEREST": "Intérêt",
      "RISK_EXPOSURE_FEE": "Frais d'exposition au risque",
      "WITHHOLDING_TAX": "Retenue d'impôt",
      "DEREGISTRATION_FEE": "Frais de retrait",
      "DEREGISTRATION_TAX": "Taxe sur retrait",
      "GST": "Taxe sur les produits et services",
      "HST": "Taxe de vente harmonisée",
      "ADJUSTMENT": "Ajustement",
      "GOV_CONTRIBUTIONS": "Contributions publiques",
      "SWITCH_IN": "Transfert d'achat",
      "CANCEL_SWITCH_IN": "Annuler le transfert d'achat",
      "CANCEL_SWITCH_OUT": "Annuler le transfert de vente",
      "DISTRIBUTION": "Placement",
      "CHEQUE": "Chèque",
      "DEPOSIT_BUY": "Achat de dépôt",
      "DISTRIBUTION_REINVESTMENT": "Réinvestissement des placements",
      "EXTERNAL_TRANSFER_IN_SECURITY": "Virement externe en valeur mobilière",
      "EXPENSE": "Dépense",
      "OTHER": "Autre",
      "TRANSFER_IN_SECURITY": "Transfert entrant de valeur mobilière",
      "TRANSFER_OUT_SECURITY": "Transfert sortant de valeur mobilière",
      "SWITCH_OUT": "Transfert de vente",
      "SWI_MARKET": "Transfert d'achat - Au prix du marché",
      "SWI_COST": "Transfert d'achat - Au prix coûtant",
      "SWO_MARKET": "Transfert de vente - Au prix du marché",
      "SWO_COST": "Transfert de vente - Au prix coûtant",
      "MARKET_DRIP": "Contenu sur le marché",
      "CUSTODY_FEE": "Droits de garde",
      "INCOME_FUND_TRANSFER": "Virement de fonds de revenu",
      "ACCRUED_INTEREST": "Intérêt accru",
      "CANADA_LEARNING_BOND": "Bon d'études canadien",
      "COMMISSION": "Commission",
      "DISABILITY_ASSISTANCE_PAYMENT": "Paiement de l'aide à l'invalidité",
      "ADD_CAD_EDU_SAVING_GRANT": "Subvention canadienne supplémentaire pour l'épargne-études",
      "HOME_BUYER_PLAN": "Régime d'accession à la propriété",
      "LIFE_LEARNING_PLAN": "Régime d’encouragement à l'éducation permanente",
      "MANAGEMENT_FEE_REDEMPTION": "Remboursement des frais de gestion",
      "REBATE": "Réduction",
      "REDEMPTION": "Remboursement",
      "RETURN_OF_CAPITAL": "Remboursement du capital",
      "WIRE_TRANSFER": "Virement bancaire",
      "WRITE_OFF": "Radier",
      "STOCK_DRIP": "Plan de réinvestissement des dividendes en actions",
      "CANCEL_BORROW_FEE": "Annuler les frais d'emprunt",
      "CANCEL_CHEQUE": "Annuler le chèque",
      "CANCEL_DEPOSIT": "Annuler le dépôt",
      "CANCEL_FEE": "Annuler les frais",
      "CANCEL_HST": "Annuler la taxe de vente harmonisée",
      "CANCEL_INTEREST": "Annuler les intérêts",
      "CANCEL_REBATE": "Annuler la réduction",
      "CANCEL_TRANSFER_IN": "Annuler le virement en valeur mobilière",
      "CANCEL_TRANSFER_OUT": "Annuler le virement sortant de valeur mobilière",
      "FEDERAL_TAX": "Impôt fédéral",
      "SHORT_TERM_GAIN_LOSS": "Gain/perte à court terme",
      "LONG_TERM_GAIN_LOSS": "Gain/perte à long terme",
      "NON_EDU_CAPITAL_WITHDRAWAL": "Retrait de capitaux non pédagogiques",
      "CANCEL_ADJUSTMENT": "Annuler l'ajustement",
      "CONTRIBUTION": "Contribution",
      "BOOK_VALUE_ADJUSTMENT": "Ajustement de la valeur comptable",
      "JOURNAL": "Journal",
      "CANCEL_JOURNAL": "Annuler le journal",
      "FOREIGN_TAX": "Impôt étranger",
      "TRANSFERS_EXCHANGES": "Virements / Échanges"
    },
    "currencies": {
      "CAD": "CAD",
      "USD": "USD"
    },
    "switchMenuItem": {
      "SWITCH": "Changement"
    },
    "switchTypes": {
      "AT_COST": "Au prix coûtant",
      "AT_MARKET": "Au prix du marché"
    },
    "journalTypes": {
      "CASH": "Espèces seulement",
      "SECURITY": "Titre seulement",
      "BOTH": "Titre + Espèces"
    },
    "newTransaction": {
      "createdToastMessage": "La transaction d'ajustement a été créée.",
      "journalCreatedToastMessage": "Les transactions de journal ont été créées.",
      "errorToastMessage": "Échec de la création de la transaction. Veuillez réessayer.",
      "title": "Nouvelle transaction",
      "portfolio": "Portefeuille",
      "date": "Date",
      "amount": "Montant",
      "details": "Détails",
      "financialProduct": "Produit",
      "quantity": "Quantité",
      "price": "Prix",
      "pricePerUnit": "Prix par unité",
      "adjustmentType": "Type d'ajustement",
      "interestType": "Type d'intérêt",
      "adjustedCostBase": "Prix de base rajusté",
      "journalType": "Type de journal",
      "toSubAccount": "Vers le sous-compte",
      "additionalCash": "Espèces supplémentaires",
      "noValidTargetSubAccounts": "Aucun sous-compte valide disponible pour le transfert. Veuillez sélectionner un portefeuille différent qui possède d'autres sous-comptes dans le même compte avec une devise correspondante.",
      "noSecurityHoldings": "Ce portefeuille n'a aucune valeur mobilière disponible pour le transfert. Seuls les portefeuilles avec des valeurs mobilières peuvent être utilisés pour les transactions de journal de type SECURITY ou BOTH.",
      "priceExceedsHoldingValue": "Prix × Quantité dépasse la valeur du titre disponible",
      "currentMarketPrice": "Prix du marché actuel: {{price}}",
      "interestTypes": {
        "DEPOSIT": "Intérêts perçus",
        "WITHDRAW": "Intérêts débités"
      },
      "security": "Valeur mobilière",
      "bookValue": "Valeur comptable",
      "executionOrder": "Ordre d'exécution",
      "executionOrderHelp": "Ordre de traitement des transactions pour les transactions de même date (0=premier, 1=deuxième)",
      "invalidDescription": "Les détails contiennent des caractères invalides"
    },
    "switchTransaction": {
      "outSecurity": "Sortie de la valeur mobilière",
      "inSecurity": "Entrée de la valeur mobilière",
      "switchInPrice": "Entrée du prix de base rajusté",
      "valueCents": "Valeur marchande totale",
      "quantity": "Quantité",
      "priceCents": "Sortie du prix de base rajusté",
      "switchedToastMessage": "Les changements de transactions ont été créés.",
      "isExistingHolding": "La sortie de la valeur mobilière est actuellement dans ce portefeuille.",
      "atCostInfo": "Le prix par unité pour l'entrée de la valeur mobilière est le coût total de la sortie de la valeur mobilière/l'entrée de la quantité.",
      "atMarketInfo": "Le prix par unité pour l'entrée de la valeur mobilière est son prix marchand actuel."
    },
    "updateTransaction": {
      "title": "Mettre à jour la transaction",
      "updatedToastMessage": "La transaction a été mise à jour.",
      "errorToastMessage": "Échec de la mise à jour de la transaction. Veuillez réessayer.",
      "pendingWarning": "Cette transaction est actuellement en attente et ne peut pas être modifiée."
    },
    "deleteTransaction": {
      "deletedToastMessage": "La transaction a été supprimée.",
      "journalDeletedToastMessage": "Les transactions de journal ont été supprimées.",
      "errorToastMessage": "Échec de la suppression de la transaction. Veuillez réessayer.",
      "title": "Supprimer la transaction",
      "body": "Voulez-vous vraiment supprimer cette transaction?"
    }
  },
  "transferSources": {
    "USER": "Client émis",
    "REPRESENTATIVE": "Représentant émis",
    "FEE": "Frais de gestion",
    "DEREGISTRATION": "Frais de retrait",
    "DEREGISTRATION_TAX": "Taxe sur retrait",
    "WITHHOLDING_TAX": "Retenue d'impôt",
    "DIVIDEND": "Dividende",
    "TO_SUB_ACCOUNT": "Vers un autre portefeuille",
    "FROM_SUB_ACCOUNT": "À partir d'un autre portefeuille",
    "TO_ACCOUNT": "Vers un autre compte",
    "FROM_ACCOUNT": "À partir d'un autre compte",
    "EXTERNAL_TRANSFER_IN": "Virement externe entrant",
    "EXTERNAL_TRANSFER_OUT": "Virement externe sortant",
    "ADJUSTMENT": "Ajustement",
    "CUSTODIAN_ACTIVITY": "Activité du dépositaire",
    "GOV_CONTRIBUTIONS": "Contributions publiques",
    "INCOME_FUND_TRANSFER": "Virement de fonds de revenu",
    "CHEQUE": "Chèque",
    "DISTRIBUTION": "Placement",
    "DSC_FEE": "Frais de rachat différé"
  },
  "transferTo": "Vers {{subAccount}}",
  "transferFrom": "À partir de {{subAccount}}",
  "ruleTypes": {
    "ABOVE_LIQUIDITY": "Au-dessus des liquidités",
    "ABOVE_NETWORTH": "Au-dessus de la valeur nette",
    "ADVERSE_NEWS": "Nouvelles défavorables",
    "DEPOSIT_IN_SAME_TIMEFRAME": "Dépôt à la même période",
    "DORMANT_ACCOUNT": "Compte inactif",
    "FOR_ACCOUNT_PURPOSE": "Pour les besoins du compte",
    "HIGH_RISK_USER": "Utilisateur à haut risque",
    "LARGE_DEPOSIT": "Dépôt important",
    "LARGE_EXTERNAL_TRANSFER": "Virement externe important",
    "LARGE_WITHDRAW_IN_SHORT_TIME": "Retrait important en peu de temps",
    "MULTIPLE_DEPOSIT_IN_SHORT_TIME": "Plusieurs dépôts en peu de temps",
    "HAS_MULTIPLE_LARGE_DEPOSITS": "Plusieurs gros dépôts",
    "HAS_MULTIPLE_LARGE_WITHDRAWALS": "Plusieurs gros retraits",
    "LARGE_WITHDRAWAL": "Gros retrait",
    "WITHDRAWAL_TO_NEW_BANK_ACCOUNT": "Retrait vers le nouveau compte bancaire"
  },
  "alertReportStates": {
    "INITIATED": "Initié",
    "REVIEW": "Examiner",
    "APPROVED": "Approuvé",
    "DENIED": "Refusé"
  },
  "subAccountTable": {
    "account": "Compte",
    "goal": "Objectif",
    "theme": "Thème",
    "suggestedPortfolio": "Suggestion de portefeuille",
    "portfolio": "Portefeuille",
    "requireIPS": "Exiger des énoncés de la politique de placement",
    "allowClientDeposits": "Dépôts du client autorisés",
    "allowFractionalShares": "Autoriser les fractions d'action",
    "nextDeposit": "Dépôt suivant",
    "assets": "Total des actifs",
    "state": "État",
    "actions": "Actions",
    "Yes": "Oui",
    "No": "Non",
    "True": "Vrai",
    "False": "Faux"
  },
  "subAccountState": {
    "AWAITING_APPROVAL": "Approbation en attente",
    "ACTIVE": "Actif",
    "INACTIVE": "Inactif",
    "WITHDRAW_ALL": "Retrait intégral"
  },
  "subAccountTransitions": {
    "activate": "Activer",
    "review": "Examiner",
    "deactivate": "Désactiver"
  },
  "scheduledFundTransferModal": {
    "warningToastMessage": "Un virement est déjà programmé vers {{content}}. Veuillez annuler ce virement vers ce compte avant d'en créer un autre.",
    "editTitle": "Modifier les instructions de paiement",
    "title": "Nouvelles instructions de paiement",
    "edit": "Modifier",
    "archive": "Archive",
    "years": "années",
    "dateOfBirth": "Âge pour calculer le paiement minimum",
    "typeOfAnnualPaymentAmount": "Type de montant du paiement annuel",
    "amountPayableType": "Type de montant",
    "schedule": "Calendrier de paiement",
    "scheduledDate": "Date programmée",
    "scheduleOptions": {
      "SEMI_ANNUALLY": "Semestriellement",
      "QUARTERLY": "Trimestriel",
      "ANNUALLY": "Annuel",
      "MONTHLY": "Mensuel"
    },
    "annualAmountCents": "Montant annuel en cents",
    "amount": "Montant",
    "typeOfAnnualPaymentAmountSources": {
      "custom": "Personnalisé",
      "minimumAnnualPayment": "Paiement minimum annuel"
    },
    "amountPayableTypeSources": {
      "gross": "BRUT",
      "net": "NET"
    },
    "starting": "À compter de",
    "taxOptionType": "Type d'option fiscale",
    "taxOptions": {
      "NO_TAX_ON_MINIMUM": "Pas d'impôt sur le minimum",
      "SPECIAL_TAX_RATE": "Taux d'imposition spécial",
      "TAX_ON_FULL": "Taxe sur la totalité"
    },
    "subAccount": "Sous-compte",
    "bankAccount": "Dépôt de paiement à",
    "specialTaxRate": "Taux d'imposition spécial"
  },
  "transferModal": {
    "title": "Nouveau virement",
    "updateTitle": "Mettre à jour le virement",
    "updateBtnTitle": "Mettre à jour",
    "schedule": "Calendrier",
    "starting": "À compter de",
    "scheduleOptions": {
      "ONE_TIME": "Juste cette fois-ci",
      "WEEKLY": "Hebdomadaire",
      "BI_WEEKLY": "Bihebdomadaire",
      "MONTHLY": "Mensuel",
      "QUARTERLY": "Trimestriel",
      "SEMI_MONTHLY": "Bimensuel"
    },
    "startingOptions": {
      "now": "Maintenant",
      "futureDate": "Date future"
    },
    "sources": {
      "adjustment": "Ajustement",
      "eft": "Transfert électronique de fonds",
      "ALL_IN_CASH": "Complet",
      "PARTIAL_CASH": "Partiel",
      "ALL_IN_KIND": "Totalement en nature",
      "externalTransferIn": "Virement externe entrant",
      "transferToSubAccount": "Virement vers un autre portefeuille",
      "cheque": "Chèque"
    },
    "externalTransfer": {
      "method": "Méthode de virement",
      "allInCash": "TOTALITÉ_EN_ESPÈCES",
      "partialCash": "PARTIELLEMENT_EN_ESPÈCES",
      "allInKind": "Tout en nature",
      "institution": "Institution",
      "transferAccountNumber": "Numéro de compte du virement",
      "relinquishingInstitution": "Institution cédante",
      "accountTypeAndNumber": "Compte (type, numéro)",
      "account": "Compte",
      "signedTransferForm": "formulaire de virement signé",
      "downloadSignedTransferForm": "Télécharger le formulaire de virement signé",
      "signedTransferFormBtnText": "Formulaire de virement signé"
    },
    "type": "Type",
    "source": "Source",
    "deposit": "Dépôt",
    "withdraw": "Retrait",
    "portfolio": "Portefeuille",
    "fromPortfolio": "À partir du portefeuille",
    "toPortfolio": "Vers le portefeuille",
    "bankAccount": "Compte bancaire",
    "amount": "Montant",
    "totalTransferAmount": "Montant total du virement",
    "clbTransferAmount": "Montant du virement pour le BEC",
    "bcGrantTransferAmount": "Montant du virement de subvention de la Colombie-Britannique",
    "transferAll": "Virer la totalité des fonds",
    "withdrawAll": "Retrait intégral",
    "exceedWithdrawAllWarning": "Il s'agit d'un retrait total : toutes les valeurs mobilières seront vendues et les fonds seront transférés sur le compte bancaire de votre choix. Veuillez identifier cette action comme un retrait intégral ou diminuez le montant.",
    "exceedTransferAllWarning": "Il s'agit d'un virement total : toutes les valeurs mobilières seront vendues et les fonds seront transférés sur le portefeuille de votre choix. Veuillez identifier cette action comme un virement intégral des fonds ou diminuez le montant.",
    "adjustmentReason": "Motif de l'ajustement",
    "createdToastMessage": "Le virement a été créé.",
    "fetchingFees": "Frais de recherche ...",
    "eftOut": "Transfert électronique de fonds sortant",
    "withdrawalMode": "Mode de retrait",
    "gross": "Brut",
    "net": "Net",
    "netAmount": "Montant net",
    "minRecurringDepositAmount": "Voici votre montant récurrent minimum :",
    "minAmountDeposit": "Voici votre dépôt récurrent minimum :",
    "minInitialDeposit": "Voici votre dépôt initial minimum :",
    "depositGreaterThanZero": "Le montant du dépôt doit être supérieur à 0",
    "selectScheduleFirst": "Veuillez sélectionner un calendrier pour continuer",
    "insufficientCurrencyBalance": "Solde {{currency}} insuffisant. Disponible: {{available}}",
    "availableCash": "Disponible: {{amount}}",
    "availableQuantity": "Disponible: {{quantity}} actions",
    "availableValue": "Disponible: {{amount}}",
    "stateTaxTitle": "Taux de retenue à la source de l'impôt de l'État",
    "federalTaxTitle": "Taux de retenue à la source de l'impôt fédéral",
    "choosePortfolio": "Choisir un portefeuille",
    "feeSourceNotSetToastMessage": "L'ajustement a été créé, mais la source des frais de gestion n'a pas pu être définie. Modifiez le virement pour la définir."
  },
  "tradeModal": {
    "title": "Nouvelle opération",
    "types": {
      "buy": "ACHETER",
      "sell": "VENDRE"
    },
    "type": "Type",
    "portfolio": "Portefeuille",
    "financialProduct": "Produit",
    "price": "Prix / Prix de base rajusté",
    "quantity": "Quantité",
    "effectiveDate": "Date d'entrée en vigueur",
    "description": "Description",
    "createdToastMessage": "L'opération a été créée.",
    "fractionalToastMessage": "Ce produit n'autorise pas les opérations fractionnées.",
    "isReconciled": "Opération rapprochée",
    "createExternalTransfer": "Créer un virement externe correspondant pour les virements en nature"
  },
  "goalType": {
    "CAR": "Voiture",
    "BUILD_WEALTH": "Bâtir vos avoirs",
    "RETIREMENT": "Retraite",
    "MAJOR_PURCHASE": "Achat majeur",
    "HOUSE": "Maison",
    "EDUCATION": "Éducation",
    "VACATION": "Vacances",
    "START_A_BUSINESS": "Lancer une entreprise",
    "WEDDING": "Mariage",
    "PARENTAL_LEAVE": "Congé parental",
    "SAFETY_NET": "Filet de sécurité",
    "OTHER": "Autre"
  },
  "taxInformationField": {
    "label": "Paiement d'impôts étrangers",
    "country": "Pays",
    "tin": "Numéro d'identification fiscale"
  },
  "externalInstitutionSelect": {
    "selectInstitutionDialog": {
      "title": "Sélectionner une institution financière",
      "addManually": "+ Ajouter une institution manuellement",
      "addInstitution": "+ Ajouter une institution"
    },
    "addInstitutionDialog": {
      "title": "Ajouter une institution manuellement",
      "institutionNameLabel": "Nom de l'institution",
      "addManually": "+ Ajouter une institution manuellement"
    },
    "confirmButton": "Confirmer"
  },
  "scheduleDateSelect": {
    "title": "Une fois le...",
    "label": "Date programmée",
    "suffix": "jour du mois"
  },
  "booleanOptions": {
    "yes": "Oui",
    "no": "Non"
  },
  "simpleDateRangePicker": {
    "fromDate": "De",
    "toDate": "À"
  },
  "portfolio": "Portefeuille",
  "viewPreTradePositions": "Afficher les positions valeur marchande pré-ouverture",
  "viewInactiveSubAccounts": "Afficher les sous-comptes inactifs",
  "portfolioLastUpdated": "Dernière mise à jour {{date}}",
  "portfolioWarnings": {
    "accountIsBlocked": "Les opérations ne seront pas exécutées, car le compte n'est pas actif et/ou approuvé",
    "subAccountIsBlocked": "Les opérations ne seront pas exécutées, car le sous-compte n'est pas actif et/ou approuvé",
    "illiquidProducts": "Les opérations impliquant des produits illiquides seront uniquement disponibles à la date ou aux dates suivantes programmées : {{datesAndTickers}}",
    "pendingTransactionUsdCurrency": "Les ordres d'opération de valeurs mobilières en USD {{tickers}} ont été exécutés, mais sont en attente de rapprochement et le montant affiché peut être différent",
    "pendingTransactionMfSellAll": "La vente de tous les ordres de fonds communs de placement {{tickers}} a été exécutée, mais est en attente de rapprochement et le montant affiché peut être différent",
    "pendingSplitsInCompletedTrades": "Il y a des divisions en attente dans le tableau des opérations terminées."
  },
  "bulkTradeRequestIsNotFound": "Erreur : la demande d'opérations groupées associée à l'optimiseur de portefeuille actuel est introuvable !",
  "errorOccurredWhileLoadingPortfolio": "Une erreur est survenue lors du chargement du portefeuille.",
  "errorPortfolioViewUnderSubAccount": "Veuillez consulter le portfolio dans le sub-account",
  "errorPortfolioViewUnderGoal": "Veuillez consulter le portfolio dans le goal",
  "revert": "Revenir en arrière",
  "autoFillToTarget": "Remplir automatiquement vers la cible",
  "autoRebalance": "Rééquilibrage automatique",
  "optimizer": "Optimiseur",
  "optimizerDisabledReason": "L'optimiseur est indisponible, car des transactions actives sont en attente",
  "showPairs": "Afficher les paires",
  "canadianCash": "Dollars canadiens",
  "pendingReconciliationAlerts": {
    "usdSecurityMessage": "Les ordres d'opération de valeurs mobilières en USD {{tickers}} ont été exécutés, mais sont en attente de rapprochement et le montant affiché peut être différent",
    "mfSellAllMessage": "La vente de tous les ordres de fonds communs de placement {{tickers}} a été exécutée, mais est en attente de rapprochement et le montant affiché peut être différent"
  },
  "portfolioTable": {
    "assetGroup": "Groupe d'actifs",
    "collapseRow": "Réduire la ligne",
    "expandRow": "Développer la ligne",
    "deleteAssetClass": "Supprimer la classe d'actifs",
    "security": "Valeur mobilière",
    "current": "Actuel",
    "target": "Cible",
    "original": "Original: {{amount}}",
    "pendingWithdraw": "Retrait en attente: {{amount}}",
    "deviation": "Écart",
    "cash": "Trésorerie",
    "total": "Total",
    "taxRank": "Rang d'imposition",
    "subAccountIsInactive": "Ce sous-compte est inactif et ne peut pas être échangé",
    "pendingReconciliation": "Rapprochement en attente",
    "initiatedBuy": "Acheter",
    "initiatedSell": "Vendre",
    "initiatedSellAll": "Tout vendre",
    "requestedBuy": "Acheter",
    "requestedSell": "Vendre",
    "requestedSellAll": "Tout vendre",
    "sellAll": "TOUT VENDRE",
    "settles": "Réglé",
    "settling": "En cours de règlement"
  },
  "noRecordsFound": "Aucun dossier trouvé",
  "generateTrades": {
    "confirmTrades": "Confirmer les opérations",
    "completeTrades": "Terminer le lot",
    "cancelTrades": "Annuler les opérations",
    "cancelSelectedTrades": "Annuler les transactions sélectionnées",
    "exportTrades": "Exporter les opérations",
    "nothingToExport": "Rien à exporter",
    "verifyTradesResult": "Les opérations ont été marquées comme vérifiées/non vérifiées",
    "unverifyTradesResult": "Les opérations ont été marquées comme non vérifiées",
    "verifyUnverifyTradesResult": "Les opérations ont été marquées comme vérifiées/non vérifiées",
    "confirm": "Confirmer",
    "tradesSent": "Opérations envoyées",
    "activeTradeRequests": "Demandes d'opération actives",
    "completedTradeRequests": "Demandes d'opération terminées",
    "generatedByPortfolioOptimizer": "Généré par un Optimiseur de portefeuille sur {{portfolioOptimizerCreatedAt}}",
    "noActiveTradeRequests": "Aucune demande d'opération active",
    "noCompletedTradeRequests": "Aucune demande d'opération terminée",
    "tradesToBeCanceled": "Opérations qui seront annulées",
    "verifyUnverifyTrades": "Vérifier/annuler la vérification des opérations",
    "allSplitsAreVerified": "Toutes les divisions sont vérifiées",
    "someSplitsAreNotVerified": "Certaines divisions ne sont pas vérifiées",
    "errorCreatingTrades": "Impossible de créer des transactions",
    "table": {
      "account": "Compte",
      "accountType": "Type de compte client",
      "custodianAccountNumber": "Numéro du compte client",
      "type": "Type",
      "amount": "Montant",
      "security": "Valeur mobilière",
      "securityTicker": "Symbole de la valeur immobilière",
      "securityName": "Nom de la valeur immobilière",
      "settlementDays": "Jours de règlement",
      "exchange": "Change",
      "settlementDate": "Date de règlement",
      "state": "État",
      "pairedWith": "Associé à",
      "selectAll": "Sélectionner toutes les opérations à vérifier ou auxquelles annuler la vérification",
      "selectAllTradesToCancel": "Sélectionner toutes les opérations à annuler",
      "selectAllTradesToVerifyOrCancel": "Sélectionner toutes les opérations à vérifier ou auxquelles annuler la vérification",
      "verifiedAt": "Vérifié",
      "currency": "Devise",
      "actions": "Actions"
    },
    "cancelSubTradeRequest": "Annuler l'opération",
    "cancelSubTradeRequestSuccess": "Opération annulée avec succès",
    "cancelSubTradeRequestError": "Échec de l'annulation de l'opération",
    "types": {
      "BUY": "Acheter",
      "SELL": "Vendre"
    }
  },
  "tradePairsModal": {
    "modalTitle": "Paires créées",
    "buys": "Achats",
    "pairedWith": "Associé à",
    "sells": "Ventes",
    "noPair": "Aucune paire",
    "totalBuys": "Montant total des achats en dollars",
    "totalSells": "Montant total des ventes en dollars",
    "sellAll": "Tout vendre"
  },
  "inherited": " - (hérité)",
  "includePendingTrades": "Inclure les opérations en cours",
  "pendingTransfers": {
    "title": "Transactions en attente",
    "details": "Détails de la transaction",
    "cancelTransaction": "Annuler la transaction",
    "cancelScheduledTransaction": "Annuler la programmation",
    "types": {
      "WITHDRAW": "Retrait",
      "DEPOSIT": "Dépôt"
    },
    "states": {
      "INITIATED": "Initié",
      "READY": "Prêt",
      "REQUESTED": "Demandé",
      "PROCESSING": "Traitement en cours",
      "ACTIVE": "Actif",
      "REVIEWING": "Examen en cours",
      "RECONCILED": "Rapproché",
      "FAILED": "Échec",
      "CANCELED": "Annulé"
    }
  },
  "beneficiaryCrud": {
    "beneficiaryName": "Nom du bénéficiaire",
    "relationshipToAccountHolder": "Relation avec le titulaire du compte",
    "allocation": "Allocation",
    "addAffiliate": "Ajouter un affilié",
    "allocationError": "Le total de l'allocation doit être égal à 100 %"
  },
  "householdMembers": {
    "title": "Membres"
  },
  "changeTheme": {
    "portfolioTheme": "Thème de portefeuille",
    "modelPortfolio": "Portefeuille modèle",
    "suggested": "Suggéré",
    "unset": "Annuler",
    "save": "Enregistrer les modifications",
    "noOptionsAvailable": "Aucun portefeuille de modèles disponible",
    "noSuitabilityScore": "Vous devez répondre à toutes vos questions d'adéquation avant de pouvoir choisir un thème",
    "modelPortfolioRequired": "Un portfolio modèle est requis"
  },
  "recentTransactions": {
    "title": "Détails des investissements récents"
  },
  "newsAndInsights": {
    "title": "Nouvelles et aperçu"
  },
  "contacts": {
    "title": "Communiquer avec votre conseiller"
  },
  "accessToEntity": {
    "title": "Accès",
    "table": {
      "name": "Nom",
      "email": "Courriel",
      "accessType": "Type d'accès",
      "relation": "Relation"
    },
    "accessTypes": {
      "fullAccess": "Accès complet",
      "limitedAccess": "Accès limité"
    },
    "oraganizationAccessRow": "Utilisateurs ayant accès aux entités {{org}}.",
    "relations": {
      "ADVISOR": "Conseiller",
      "OTHER": "Autre",
      "OWNER": "Client (propriétaire)",
      "POWER_OF_ATTORNEY": "Procuration"
    },
    "editButton": {
      "title": "Modifier l'accès à {{entityName}}",
      "update": "Mettre à jour"
    },
    "addButton": {
      "formTitle": "Accorder l'accès à {{entityName}}",
      "relationLabel": "Relation",
      "grantAccessButton": "Accorder l'accès",
      "orgUserSearchText": "Utilisateur",
      "entitySearchText": "Entités",
      "accounts": "Comptes",
      "allowAccessToSpecificAccounts": "Autoriser l'accès uniquement à certains comptes",
      "noAccountsSelectedError": "Aucun compte spécifique sélectionné : cet utilisateur n'aura aucun accès sous cette entité",
      "toggle": {
        "create": "Créer un nouvel utilisateur",
        "invite": "Inviter un utilisateur existant"
      },
      "createTab": {
        "firstName": "Prénom",
        "lastName": "Nom de famille",
        "relation": "Relation",
        "email": "Courriel",
        "organization": "Organisation",
        "role": "Rôle",
        "roleToAccessEntity": "Rôle pour accéder à l'entité",
        "noRoleSelected": "Si aucun rôle n'est sélectionné, l'accès sera accordé en fonction du rôle de l'utilisateur de l'organisation.",
        "autoInviteUser": "Inviter automatiquement l'utilisateur",
        "emailError": "Cet utilisateur existe déjà. Invitez l'utilisateur existant."
      }
    },
    "confirmationModal": {
      "title": "Confirmez-vous?",
      "bodyText": "Voulez-vous vraiment supprimer l'accès de {{orgUserName}} au profil de {{entityName}}?"
    }
  },
  "additionalInfoModal": {
    "title": "Ce que cela signifie"
  },
  "viewAllProfilesDialog": {
    "switchProfile": "Changer de profil",
    "viewDetails": "Afficher les détails",
    "addNewEntity": "Ajouter un nouveau profil"
  },
  "translatableString": {
    "errorText": "Champ manquant"
  },
  "subTradeRequestTableDialog": {
    "title": "Voulez-vous vraiment annuler cette demande d'opération?"
  },
  "exportConfiguration": {
    "title": "Exporter la configuration",
    "useAdditionalFilter": "Appliquer le filtre à l'exportation",
    "mainColumns": "Colonnes principales",
    "additionalColumns": "Colonnes supplémentaires",
    "selectAllColumns": "Sélectionner toutes les colonnes",
    "exportButton": "Exporter",
    "dateRange": "Période",
    "fromDate": "À partir de la date",
    "toDate": "Jusqu'à la date",
    "specifyDateRange": "Précisez une période",
    "dateRangeError": "La période ne peut pas dépasser {{days}} jours",
    "maxDateRange": "La période maximale est de {{days}} jours",
    "futureDateError": "La date ne peut pas si situer dans le futur",
    "startDateAfterEndError": "La date de début ne peut pas se situer après la date de fin",
    "bothDatesRequiredError": "Saisissez les dates De et À, ou effacez-les toutes les deux.",
    "invalidDateError": "Date non valide",
    "fileName": "Nom du fichier"
  },
  "dateRangeField": {
    "from": "De",
    "to": "À",
    "clear": "Effacer",
    "apply": "Appliquer"
  },
  "downloadButton": {
    "failedDownloadMessage": "Fichier non téléchargé",
    "progressModalTitle": "Préparation de l'exportation",
    "download": "Télécharger",
    "exportProgressPercent": "{{percent}}%",
    "noExportsFound": "Aucune exportation trouvée",
    "recentExports": "Exportations récentes",
    "createExport": "Créer une exportation",
    "exportColumnsCount_one": "{{count}} colonne",
    "exportColumnsCount_other": "{{count}} colonnes",
    "exportRefetchTimeout": "L'exportation a démarré, mais n'est pas apparue dans la liste. Actualisez et réessayez."
  },
  "searchSecuritiesField": {
    "nothingFoundMessage": "Aucun titre trouvé avec ce ticker."
  },
  "marketValueChart": {
    "netContributions": "Cotisations nettes:"
  },
  "view": "Voir",
  "fundFacts": "Informations sur le fonds",
  "ruleBuilder": {
    "addRule": "Ajouter une règle",
    "addGroup": "Ajouter un groupe",
    "removeRuleGroup": "Supprimer le groupe",
    "noAvailableRules": "Aucun champ n'est disponible pour ce type d'objet. Ajoutez un champ personnalisé pour ce type afin de créer une condition.",
    "and": "ET",
    "or": "OU",
    "operators": {
      "equals": "Est égal à",
      "notEquals": "N'est pas égal à",
      "contains": "Contient",
      "notContains": "Ne contient pas",
      "startsWith": "Commence par",
      "endsWith": "Se termine par",
      "greaterThan": "Supérieur à",
      "greaterThanOrEquals": "Supérieur ou égal à",
      "lessThan": "Inférieur à",
      "lessThanOrEquals": "Inférieur ou égal à",
      "in": "Dans",
      "notIn": "Pas dans",
      "exists": "Existe",
      "notExist": "N'existe pas",
      "isEmpty": "Est vide",
      "isNotEmpty": "N'est pas vide",
      "isTrue": "Est vrai",
      "isFalse": "Est faux",
      "isBefore": "Est avant",
      "isAfter": "Est après",
      "includes": "Compris",
      "notIncludes": "Non compris"
    }
  },
  "rules": {
    "state": "État",
    "marketValue": "Valeur du marché",
    "age": "Âge",
    "dateOfBirth": "Date de naissance",
    "accountType": "Type de compte",
    "createdAt": "Créé à"
  },
  "fieldErrors": {
    "default": "Champ {{fieldName}} obligatoire",
    "phone": "Veuillez entrer un numéro de téléphone valide",
    "email": "Entrez une adresse courriel valide",
    "selectionTile": "Veuillez sélectionner une option",
    "address": "Veuillez entrer une adresse complète"
  },
  "productShelf": {
    "exportHeaders": {
      "ticker": "Symbole",
      "name": "Nom",
      "exchange": "Change",
      "primaryAssetClass": "Catégorie d'actifs primaires",
      "secondaryAssetClass": "Catégorie d'actifs secondaires",
      "substitute": "Produit de remplacement",
      "taxRank": "Rang d'imposition",
      "tradeSchedule": "Calendrier des opérations",
      "currency": "Devise",
      "currentPrice": "Prix actuel",
      "originalCurrency": "Devise originale",
      "originalPrice": "Prix original",
      "autoUpdatePrice": "Mettre à jour le prix automatiquement",
      "historyDate": "Date historique",
      "priceHistory": "Historique de prix",
      "holdingsQuantityHistory": "Historique des quantités d'actifs",
      "holdingsValueHistory": "Historique des valeurs d'actifs",
      "fundSeries": "Série de fonds",
      "cusip": "CUSIP",
      "volatile": "Volatil",
      "isPartial": "Fractionnaire",
      "tertiaryAssetClass": "Catégorie d'actifs tertiaire",
      "waivedFeePercentage": "Pourcentage des frais exonérés",
      "settlementDays": "Jours de règlement",
      "url": "URL",
      "isin": "ISIN",
      "ric": "RIC",
      "type": "Type",
      "multiplier": "Multiplicateur"
    },
    "exportConfig": {
      "includeHistory": "Historique de prix compris",
      "historyFrom": "Historique à partir de",
      "historyTo": "Historique jusque",
      "progressTitle": "Exportation des données sur l'étagère de produits"
    }
  },
  "featureFlags": {
    "inheritedSetTo": "Récupération définie sur",
    "true": "Oui",
    "false": "Non"
  },
  "updateTransferModal": {
    "title": "Mise à jour",
    "source": "Source",
    "amount": "Montant",
    "type": "Type",
    "updatedToastMessage": "Le transfert a été mis à jour."
  },
  "modelPortfolioHolding": {
    "noPortfolioHolding": "Aucune répartition des avoirs n'est disponible",
    "errorStateTitlePortfolioHolding": "Impossible de charger la répartition des fonds"
  },
  "holdings": {
    "noHoldings": "Vous n'avez aucune participation",
    "errorStateTitleHoldings": "Impossible de charger les actifs",
    "searchPlaceholder": "Rechercher des avoirs",
    "noMatchingHoldings": "Aucun avoir ne correspond à votre recherche"
  },
  "affiliateConversion": {
    "inviteUser": "Inviter l'utilisateur",
    "edit": "Modifier",
    "delete": "Supprimer",
    "confirmation": {
      "title": "Confirmez-vous?",
      "subTitle": "Veuillez confirmer que vous attribuez l'utilisateur de l'entité correcte ({{entityUserEmail}})"
    }
  },
  "usaContributionTypes": {
    "REGULAR": "Régulier",
    "EMPLOYEE": "Employé",
    "EMPLOYER": "Employeur",
    "RECHARACTERIZATION": "Requalification",
    "ROLLOVER_60_DAY": "Refinancement sur 60 jours",
    "ROLLOVER_DIRECT": "Refinancement direct",
    "TRANSFER": "Virement",
    "TRUSTEE_FEE": "Frais de fiducie",
    "CONVERSION": "Conversion",
    "REPAYMENT": "Remboursement"
  },
  "usaContributionTypeTitle": "Type de contribution",
  "fiscalYearTitle": "Année fiscale",
  "clientSelect": {
    "affiliate": "Affiliation",
    "selectUser": "Sélectionner un utilisateur"
  },
  "usaWithdrawalReasons": {
    "IRA_DISTRIBUTION_TYPE_UNKNOWN": "Type de placement de PER inconnu",
    "NORMAL": "Normal",
    "DISABILITY": "Handicap",
    "SOSEPP": "Série de paiements périodiques sensiblement égaux",
    "PREMATURE": "Pérmaturé",
    "DEATH": "Décès",
    "EXCESS_CONTRIBUTION_REMOVAL_BEFORE_TAX_DEADLINE": "Suppression des cotisations excédentaires avant la date limite d'imposition",
    "EXCESS_CONTRIBUTION_REMOVAL_AFTER_TAX_DEADLINE": "Suppression des cotisations excédentaires après la date limite d'imposition",
    "ROLLOVER_TO_QUALIFIED_PLAN": "Refinancement vers un plan qualifié",
    "ROLLOVER_TO_IRA": "Refinancement sur un PER",
    "DISTRIBUTION_TRANSFER": "Virement de placement",
    "RECHARACTERIZATION_PRIOR_YEAR": "Requalification de l'année précédente",
    "RECHARACTERIZATION_CURRENT_YEAR": "Requalification de l'année en cours",
    "DISTRIBUTION_CONVERSION": "Conversion des placements",
    "MANAGEMENT_FEE": "Frais de gestion",
    "PLAN_LOAN_401_K": "Prêt du plan 401(k)",
    "PREMATURE_SIMPLE_IRA_LESS_THAN_2_YEARS": "PER simple prématuré de moins de deux ans",
    "NORMAL_ROTH_IRA_GREATER_THAN_5_YEARS": "PER normal exonéré d'impôt de plus de cinq ans"
  },
  "usaWithdrawalReasonTitle": "Motif du retrait",
  "stateTaxMessages": {
    "info": {
      "mandatory": "{{state}} exige une retenue d'impôt de l'État (min. {{minTaxWithholding}}) lorsque l'impôt fédéral est retenu. Si vous bénéficiez d'une exonération de la retenue fédérale, vous pouvez refuser de vous y soumettre. Si vous choisissez de retenir l'impôt, le minimum continue de s'appliquer.",
      "mandatoryOptOut": "{{state}} exige une retenue d'impôt de l'État (min. {{minTaxWithholding}}) lorsque l'impôt fédéral est retenu. Un formulaire propre à chaque État est nécessaire pour exercer un refus, mais il n'est pas pris en charge actuellement. Si vous bénéficiez d'une exonération de la retenue fédérale, vous pouvez refuser de vous y soumettre. Si vous choisissez de retenir l'impôt, le minimum continue de s'appliquer.",
      "noElection": "{{state}} n'autorise pas la retenue d'impôt sur le revenu de l'État pour les placements de PER.",
      "voluntaryWithMinimum": "Pour {{state}}, vous n'êtes pas tenu de retenir des fonds au titre de l'impôt de l'État. Toutefois, si vous décidez de procéder à une telle retenue, le minimum est de {{minTaxWithholding}} %.",
      "voluntary": "Pour {{state}}, vous n'avez pas besoin de retenir des fonds au titre de la retenue d'impôt de l'État.",
      "stateSpecific": {
        "DC": "Pour {{state}}, vous n'êtes pas tenu de retenir des fonds au titre de la retenue d'impôt de l'État si vous ne clôturez pas entièrement votre compte PER. Toutefois, si vous décidez de clôturer entièrement votre compte PER, un minimum est de {{minTaxWithholding}} % est requis.",
        "CA": "Pour {{state}}, vous n'êtes pas tenu de retenir des fonds au titre de l'impôt de l'État. Toutefois, si vous décidez de procéder à une telle retenue, le minimum est de {{minTaxWithholding}} % de votre retenue d'impôt fédéral.",
        "VT": "{{state}} exige une retenue d'impôt de l'État lorsque l'impôt fédéral est retenu. Le minimum est de {{minTaxWithholding}} % de votre retenue d'impôt fédéral.",
        "MS": "La loi de {{state}} exige une retenue d'impôt de l'État uniquement sur les placements de PER exonérés d'impôts qui sont considérés comme des retraits prématurés ou excédentaires. La retenue volontaire n'est pas autorisée. Nous ne sommes pas en mesure de déterminer si votre placement spécifique répond à ces critères. Pour savoir si votre retrait doit faire l'objet d'une retenue d'impôt de l'État, veuillez communiquer avec votre conseiller."
      }
    },
    "validation": {
      "minTaxWithholding": "Vous devez retenir au moins {{minTaxWithholding}} % au titre de la retenue d'impôt de l'État.",
      "optOutOrMinTaxWithholding": "Le taux de retenue d'impôt de l'État doit être de {{optOutTaxWithholding}} % ou supérieur à {{minTaxWithholding}} %"
    }
  },
  "tableColumns": {
    "account": "Compte",
    "type": "Type",
    "source": "Source",
    "state": "État",
    "createdAt": "Créé à",
    "value": "Valeur",
    "scheduledAt": "Date",
    "securityName": "Nom de sécurité",
    "frequency": "Fréquence",
    "bankAccountInstitution": "Numéro de l'institution",
    "bankAccountTransitNumber": "Numéro de transit",
    "bankAccountNumber": "Numéro de compte bancaire",
    "accountId": "Compte",
    "firstName": "Prénom",
    "lastName": "Nom",
    "currency": "Devise",
    "subAccount": "Sous-compte",
    "goal": "Objectif",
    "user": "Utilisateur",
    "organization": "Organisation",
    "householdClientGroup": "Groupe client ménage",
    "symbol": "Symbole",
    "quantity": "Quantité",
    "bookCost": "Coût du livre",
    "currentPrice": "Prix actuel",
    "unrealizedGainLoss": "G/L non réalisé",
    "oneDayChange": "Changement de 1 jour",
    "percentOfTotal": "% du total",
    "marketValueNative": "Valeur du marché (native)",
    "marketValue": "Valeur du marché",
    "name": "Nom",
    "holder": "Titulaire",
    "nickname": "Surnom",
    "accountNumber": "Compte #",
    "program": "Programme",
    "currentValue": "Valeur actuelle",
    "amount": "Montant",
    "nextScheduledDate": "Date suivante programmée",
    "costPrice": "Prix d'achat",
    "date": "Date",
    "accountGroupName": "Nom du groupe de comptes",
    "numberOfAccounts": "Nombre de comptes",
    "security": "Sécurité",
    "assetClass": "Classe d'actifs",
    "taxRank": "Rang fiscal",
    "targetPercentage": "Cible %",
    "actualPrice": "Prix réel",
    "actualQuantity": "Quantité réelle",
    "expectedPrice": "Prix prévu",
    "expectedQuantity": "Quantité prévue",
    "reconciledAt": "Réconcilié",
    "repCode": "Code de représentant",
    "cusip": "CUSIP"
  },
  "tableColumnDescriptions": {
    "localCost": "Le coût du titre par action dans la devise dans laquelle il a été exécuté",
    "localBookValue": "Le coût total du titre dans la devise dans laquelle il a été exécuté",
    "nativeCost": "Le coût natif du titre par action converti dans la devise native du compte",
    "nativeBookValue": "Le coût total du titre converti dans la devise native du compte",
    "custodianBookValue": "La valeur comptable des avoirs telle que déclarée par le dépositaire",
    "fxRate": "Taux de change historique utilisé lors de l'échange pour acheter le titre"
  },
  "portfolioFxRate": "Taux de change {{from}} à {{to}} : {{fxRate}}",
  "holdingsExchangeRate": "Taux de change : 1 {{fromCurrency}} = {{rate}} {{toCurrency}}",
  "datePicker": {
    "cancelButtonLabel": "Annuler",
    "okButtonLabel": "OK",
    "datePickerDefaultToolbarTitle": "Sélectionner une date",
    "dateTimePickerDefaultToolbarTitle": "Sélectionner la date et l'heure"
  },
  "fieldValidation": {
    "required": "Veuillez remplir ce champ.",
    "enterNumber": "Veuillez entrer un nombre."
  },
  "customFieldsDisplay": {
    "noCustomFields": "Vous n'avez pas de champs personnalisés"
  },
  "accountGroups": {
    "noAccountGroupsExist": "Aucun groupe de comptes n'existe",
    "errorFetchingAccountGroups": "Impossible de charger les groupes de comptes"
  },
  "householdModelPortfolio": {
    "initialize": "Initialiser",
    "edit": "Modifier",
    "tabs": {
      "model": "Modèle",
      "ips": "IPS"
    },
    "noIpsFieldsConfigured": "Aucun champ IPS configuré",
    "ipsContentPending": "Le contenu IPS apparaîtra ici lorsque les champs configurés seront activés.",
    "noAccess": "Vous n'avez pas l'autorisation d'afficher les portefeuilles modèles.",
    "error": "Impossible de charger le portefeuille modèle de la famille.",
    "modelDetails": {
      "title": "Détails du modèle",
      "noModelAttached": "Aucun portefeuille modèle n'est encore joint à cette famille.",
      "error": "Impossible de charger les détails du modèle."
    },
    "allocation": {
      "error": "Impossible de charger l'allocation d'actifs.",
      "noSecurities": "Aucun titre n'est encore alloué à ce portefeuille modèle."
    },
    "ips": {
      "error": "Impossible de charger le contenu IPS.",
      "noTargetAllocations": "Aucune allocation cible n'est encore configurée pour ce portefeuille modèle."
    }
  },
  "householdPortfolio": {
    "attachModel": "Joindre un modèle",
    "selectTheme": "Thème",
    "selectModel": "Portefeuille modèle",
    "attachModelSuccess": "Modèle joint",
    "attachModelError": "Impossible de joindre le modèle. Veuillez réessayer.",
    "noModelAttached": "Aucun portefeuille modèle n'est encore joint à cette famille. Joignez-en un pour afficher le portefeuille.",
    "managePortfolio": "Gérer le portefeuille de la famille",
    "detachModel": "Détacher le modèle",
    "detachModelTitle": "Détacher le modèle de la famille?",
    "detachModelBody": "Cela supprime le portefeuille modèle de la famille. L'onglet du portefeuille sera vide jusqu'à ce qu'un nouveau modèle soit joint. Les remplacements d'allocation personnalisés seront effacés.",
    "detachModelSuccess": "Modèle détaché",
    "detachModelError": "Impossible de détacher le modèle. Veuillez réessayer.",
    "tradingProcess": "Processus d'opération",
    "updateSuccess": "Portefeuille de la famille mis à jour",
    "updateError": "Impossible de mettre à jour le portefeuille de la famille. Veuillez réessayer.",
    "tradingProcessRequired": "Sélectionnez un processus d'opération",
    "portfolioStillBeingPrepared": "Le portefeuille de la famille est toujours en cours de préparation. Veuillez réessayer dans un instant.",
    "methodology": "Méthodologie d'allocation",
    "unified": "Unifiée",
    "customized": "Personnalisée",
    "errors": {
      "generic": "Une erreur s'est produite. Veuillez réessayer.",
      "NOT_CUSTOMIZED": "Ce rapport n'est pas en mode personnalisé. Actualisation…",
      "WRONG_REPORT_MEMBER": "L'ensemble des membres a changé. Actualisation du rapport…",
      "PRODUCT_NOT_HELD": "Cette valeur mobilière n'est pas détenue dans ce compte.",
      "CAPACITY_BREACH": "L'allocation doit être comprise entre 0 % et 100 %.",
      "WEIGHT_SUM_OUT_OF_RANGE": "Les allocations de ce compte ne totalisent pas correctement.",
      "AMOUNT_SUM_OUT_OF_RANGE": "Les montants en dollars de ce compte ne totalisent pas correctement.",
      "AGGREGATE_CONSERVATION": "Les totaux de la famille ne correspondent pas à la cible du modèle.",
      "BAD_USER_INPUT": "Aucune modification à enregistrer.",
      "SOLVE_FAILED": "Impossible de rééquilibrer les cibles déverrouillées. Essayez d'ajuster vos remplacements.",
      "NOT_ACCESSIBLE": "Les allocations personnalisées nécessitent plus d'un compte de membre négociable.",
      "PORTFOLIO_RESTRICTED": "Les portefeuilles de famille ne sont pas activés pour cette organisation.",
      "LOCKS_INFEASIBLE": "Les blocages actuels et les avoirs de compte disponibles ne peuvent pas satisfaire les cibles de la famille."
    },
    "modelAttachedNoMembers": "Un portefeuille modèle est joint. Le portefeuille de la famille apparaîtra une fois que cette famille aura au moins un sous-compte.",
    "inheritedFromHousehold": "Ce compte hérite du portefeuille modèle de la famille.",
    "goalInheritedFromHousehold": "Cet objectif hérite du portefeuille modèle de la famille.",
    "goalLoadFailedName": "Objectif sélectionné",
    "goalLoadFailed": "Impossible de charger les détails du portefeuille de la famille pour cet objectif. Sélectionnez un thème et un modèle manuellement, ou réessayez plus tard.",
    "unitDollar": "$",
    "unitPercent": "%",
    "unit": "Unité d'entrée",
    "customTarget": "Cible personnalisée",
    "customTargetInputLabel": "Cible personnalisée pour {{security}} dans {{member}}",
    "recalculate": "Recalculer",
    "save": "Enregistrer",
    "unsavedChangesTitle": "Annuler les modifications?",
    "unsavedChangesBody": "Vous avez des modifications d'allocation non enregistrées. Voulez-vous les annuler?",
    "unsavedAllocationGateTitle": "Modifications d'allocation non enregistrées",
    "unsavedAllocationGateBody": "Vous avez des modifications d'allocation personnalisées non enregistrées. Vous pouvez continuer sans enregistrer, ou revenir en arrière et enregistrer d'abord.",
    "proceedWithoutSaving": "Continuer sans enregistrer",
    "goBackAndSaveFirst": "Revenir en arrière et enregistrer d'abord",
    "resetCustomTargets": "Réinitialiser",
    "resetCustomTargetsTitle": "Réinitialiser les cibles personnalisées?",
    "saveCustomAllocationsSuccess": "Cibles personnalisées enregistrées",
    "resetCustomAllocationsSuccess": "Cibles personnalisées réinitialisées",
    "advisoryViolations": {
      "WEIGHT_SUM": "Cibles personnalisées mises en évidence : les allocations de titres d'un ou plusieurs comptes ne totalisent pas le montant total investissable (hors trésorerie). Ajustez vos remplacements ou bloquez moins de cellules, puis Recalculez.",
      "ROW_DRIFT": "Cibles personnalisées mises en évidence : le total d'un fonds de la famille ne correspond pas à la cible du modèle. Ajustez les valeurs bloquées ou modifiez les cellules que vous remplacez.",
      "MULTIPLE": "Certaines cibles personnalisées recalculées sont mises en évidence parce qu'elles ne correspondent pas à vos remplacements ou qu'un titre dépasse son poids dans la classe d'actifs. Examinez les champs mis en évidence ou ajustez les valeurs bloquées, puis Recalculez. La sauvegarde reste désactivée tant qu'un titre dépasse son poids dans la classe d'actifs.",
      "CAPACITY": "Cibles personnalisées mises en évidence : un titre dépasse son poids dans la classe d'actifs dans un compte. Diminuez-le ou déplacez l'excédent vers un autre compte, puis Recalculez. La sauvegarde reste désactivée jusqu'à ce moment."
    },
    "customTargetNotHeld": "Ce compte ne détient pas ce fonds",
    "customTargetNotTradeable": "Ce compte n'est pas négociable (inactif, en attente d'approbation ou fermé), donc ses cibles personnalisées ne peuvent pas être modifiées",
    "inactiveMembersInTotalsNotice": "Cette famille comprend des membres inactifs ou en attente d'approbation. Recalculer et Enregistrer les excluent, et leurs cibles personnalisées ne peuvent pas être modifiées — activez « Afficher les sous-comptes inactifs » pour les voir.",
    "resetCustomTargetsBody": "Cela réinitialise les cibles personnalisées de tous les membres négociables au modèle de la famille. Les modifications non enregistrées seront perdues.",
    "capacityLimit": "Chaque titre peut représenter au maximum {{max}} % d'un compte dans ce modèle de classe d'actifs. Diminuez ce montant ou déplacez le reste vers un autre compte.",
    "percentageOutOfRange": "Saisissez un pourcentage entre 0 et 100",
    "tradeNotHeld": "Ce compte ne détient pas ce fonds, il n'y a donc rien à négocier",
    "tradeNotTradeable": "Ce compte n'est pas négociable, les opérations ne peuvent donc pas être saisies"
  },
  "errorPortfolioViewUnderHousehold": "Le portefeuille modèle est attribué à la famille. Veuillez le consulter sur la page de la famille.",
  "errorPortfolioViewUnderSubAccounts": "Les portefeuilles modèles sont attribués au niveau du sous-compte. Veuillez les consulter sur les pages des sous-comptes pertinents.",
  "errorPortfolioStillBeingPrepared": "Le portefeuille est toujours en cours de préparation. Veuillez réessayer dans un instant.",
  "errorPortfolioNoModelAssigned": "Aucun portefeuille modèle n'est attribué à ce niveau.",
  "autocomplete": {
    "noOptions": "Aucun résultat",
    "loading": "Recherche en cours…",
    "typeToSearch": "Tapez pour rechercher",
    "minChars": "Tapez au moins {{count}} caractères",
    "loadingMore": "Chargement en cours…"
  },
  "driftSettings": {
    "label": "Politique de dérive en vigueur : {{method}} ±{{tolerance}}%",
    "inheritedFromModelPortfolio": " (hérité du portefeuille modèle)"
  },
  "optimizerEmptyRun": {
    "internalDriftAdvisory": "Ce portefeuille présente une dérive interne au sein d'une catégorie d'actifs. La dérive interne n'est qu'un avis et ne déclenche pas de rééquilibrage automatique de la dérive. Utilisez le remplissage automatique vers la cible ou saisissez les opérations manuellement.",
    "notDriftEligible": "Ce portefeuille n'est pas admissible à la dérive — il se situe dans la bande de tolérance de dérive au niveau du filtrage, donc l'optimiseur n'a pas proposé d'opérations.",
    "notProcessed": "L'optimiseur n'a pas traité ce portefeuille pour cette exécution.",
    "pendingTrades": "Des opérations sont toujours en attente sur ce portefeuille."
  },
  "viewPortfolioWideTargetPercentages": "Afficher les pourcentages cibles à l'échelle du portefeuille",
  "advisorContact": {
    "loading": "Chargement des coordonnées du conseiller…",
    "loadFailed": "Impossible de charger les coordonnées du conseiller."
  },
  "accountAllocationGrid": {
    "fundColumn": "Fonds",
    "householdActualColumn": "Réel du ménage %",
    "readOnlyAccount": "Lecture seule",
    "nonTradeableNote": "Les comptes inactifs ou en attente d'approbation ne peuvent pas être alloués tant qu'ils ne sont pas actifs.",
    "cellLocked": "Verrouillé",
    "cellUploaded": "Importé",
    "releaseCell": "Déverrouiller {{security}} pour {{account}}",
    "undo": "Annuler les modifications",
    "recalculate": "Recalculer",
    "legend": {
      "label": "Légende des cellules",
      "locked": "Modifié par vous",
      "uploaded": "Importé depuis un fichier CSV"
    },
    "csvTemplate": {
      "securityColumn": "Valeur mobilière",
      "fundIdColumn": "ID du fonds",
      "filename": "Modèle d'allocation par compte"
    },
    "csvUpload": {
      "upload": "Télécharger le fichier CSV",
      "modalTitle": "Importer un fichier CSV",
      "modalDescription": "Importez un fichier CSV pour mettre à jour l'allocation des comptes. Partez du modèle pour que chaque compte et chaque fonds soient reconnus. Seules les valeurs que vous modifiez sont mises à jour.",
      "import": "Importer le fichier",
      "success_one": "{{count}} cellule mise à jour à partir du fichier CSV.",
      "success_other": "{{count}} cellules mises à jour à partir du fichier CSV.",
      "nothingChanged": "Le fichier correspond à la grille : rien n'a changé.",
      "errorTitle": "Impossible d'importer ce fichier",
      "errorIntro": "Rien n'a changé. Corrigez ces problèmes dans le fichier, puis importez-le de nouveau.",
      "warningTitle": "Vérifier cette importation",
      "warningIntro": "Importer applique le reste du fichier.",
      "blankAccount": "(vide)",
      "issues": {
        "WRONG_FILE_TYPE": "Seuls les fichiers CSV peuvent être importés.",
        "FILE_TOO_LARGE": "Ce fichier dépasse {{maxMb}} Mo.",
        "UNREADABLE_FILE": "Ce fichier n'a pas pu être lu comme un fichier CSV. Partez du modèle téléchargé et réessayez.",
        "TOO_MANY_ROWS": "Ce fichier compte plus de {{maxRows}} lignes de fonds.",
        "NO_ACCOUNT_COLUMNS": "Ce fichier ne contient aucune colonne de compte. Partez du modèle téléchargé.",
        "UNKNOWN_ACCOUNT": "Colonne {{column}} : le compte {{accountNumber}} ne fait pas partie de cette famille.",
        "READ_ONLY_ACCOUNT": "Colonne {{column}} : le compte {{accountNumber}} est en lecture seule et ne peut pas être importé.",
        "DUPLICATE_ACCOUNT": "Colonne {{column}} : le compte {{accountNumber}} apparaît plus souvent que dans la grille.",
        "DUPLICATE_FUND": "Ligne {{row}} : {{fund}} apparaît plus d'une fois.",
        "INVALID_VALUE": "Ligne {{row}} : « {{value}} » pour {{fund}} dans le compte {{accountNumber}} n'est pas un nombre. Saisissez un pourcentage, par exemple 12.5.",
        "VALUE_OUT_OF_RANGE": "Ligne {{row}} : {{value}} pour {{fund}} dans le compte {{accountNumber}} n'est pas compris entre 0 et 100.",
        "FUND_NOT_HELD": "Ligne {{row}} : le compte {{accountNumber}} ne détient pas {{fund}}; laissez la valeur à 0 ou vide.",
        "UNKNOWN_FUND": "Ligne {{row}} : {{fund}} ne fait pas partie du modèle de cette famille; la ligne sera ignorée.",
        "FUND_MATCHED_BY_TICKER": "Ligne {{row}} : l'identifiant de fonds {{value}} est introuvable; {{fund}} a été associé par son symbole.",
        "MISSING_ACCOUNT": "Le compte {{accountNumber}} n'a pas de colonne; ses cellules ne changeront pas."
      }
    },
    "comparison": {
      "proposedColumn": "Proposé",
      "currentColumn": "Actuel",
      "changedFrom": "Modifié de {{current}} à {{proposed}}",
      "fundsOffTarget": "Les valeurs marchandes ont évolué depuis la modification, ces fonds s'écartent donc de leur cible du ménage : {{funds}}. Les répartitions s'appliquent telles que signées et peuvent être rééquilibrées ensuite."
    },
    "householdTargetColumn": "Cible du ménage %"
  },
  "modelPortfolioSearchField": {
    "searchFailed": "Impossible de rechercher les portefeuilles modèles.",
    "emptyList": "Aucun portefeuille modèle ne correspond à cette recherche."
  },
  "securitySearchSelect": {
    "searchFailed": "Impossible de rechercher dans l'étagère de produits.",
    "emptyList": "Aucune valeur mobilière ne correspond à cette recherche."
  },
  "createdFrom": "Créé à partir du",
  "createdTo": "Créé jusqu'au"
}
